"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
var react_1 = __importStar(require("react"));
var constants_1 = require("../../../constants");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var atoms_1 = require("../../atoms");
var RadioButton = function (_a) {
    var _b = _a.wrapperClassName, wrapperClassName = _b === void 0 ? 'tw-flex tw-justify-start tw-items-center tw-cursor-pointer tw-border tw-box-border tw-rounded-[10px] tw-pl-2 tw-pr-[22px] tw-h-12' : _b, _c = _a.wrapperSelectedClassName, wrapperSelectedClassName = _c === void 0 ? 'tw-border-TEXT_PRIMARY' : _c, _d = _a.wrapperDefaultClassName, wrapperDefaultClassName = _d === void 0 ? 'tw-border-DIVIDER_GRAY' : _d, _e = _a.labelClassName, labelClassName = _e === void 0 ? '' : _e, _f = _a.labelSelectedClassName, labelSelectedClassName = _f === void 0 ? 'f-16-400 tw-text-TEXT_PRIMARY' : _f, _g = _a.labelDefaultClassName, labelDefaultClassName = _g === void 0 ? 'f-16-300 tw-text-TEXT_SECONDARY' : _g, _h = _a.wrapperStyle, wrapperStyle = _h === void 0 ? '' : _h, _j = _a.wrapperSelectedStyle, wrapperSelectedStyle = _j === void 0 ? '' : _j, _k = _a.wrapperDefaultStyle, wrapperDefaultStyle = _k === void 0 ? '' : _k, _l = _a.labelStyle, labelStyle = _l === void 0 ? '' : _l, _m = _a.labelSelectedStyle, labelSelectedStyle = _m === void 0 ? '' : _m, _o = _a.labelDefaultStyle, labelDefaultStyle = _o === void 0 ? '' : _o, _p = _a.radioProps, radioProps = _p === void 0 ? {} : _p, _q = _a.checked, checked = _q === void 0 ? false : _q, onSelect = _a.onSelect, label = _a.label, _r = _a.isClearable, isClearable = _r === void 0 ? true : _r, id = _a.id, eventCallback = _a.eventCallback;
    var _s = react_1.useState(checked), isSelected = _s[0], setIsSelected = _s[1];
    react_1.useEffect(function () {
        setIsSelected(function (isSelected) { return (checked !== isSelected ? checked : isSelected); });
    }, [checked]);
    var handleSelect = function () {
        var currentStatus = !isSelected;
        setIsSelected(currentStatus);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(currentStatus);
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.RADIO_BUTTON_CLICK, { id: id, currentStatus: currentStatus });
    };
    return (react_1.default.createElement("div", { className: wrapperClassName + " " + wrapperStyle + " " + (isSelected
            ? wrapperSelectedClassName + " " + wrapperSelectedStyle
            : wrapperDefaultClassName + " " + wrapperDefaultStyle), role: 'presentation', onClick: isClearable || !isSelected ? handleSelect : constants_1.defaultFn, "data-testid": "radio-btn-" + id },
        react_1.default.createElement(atoms_1.Radio, __assign({ radioStyle: 'hover:!tw-ring-0' }, radioProps, { checked: isSelected, isClearable: isClearable, id: "radio-btn-" + id, eventCallback: eventCallback })),
        react_1.default.createElement("div", { className: labelClassName + " " + labelStyle + " " + (isSelected
                ? labelSelectedClassName + " " + labelSelectedStyle
                : labelDefaultClassName + " " + labelDefaultStyle), "data-testid": "radio-btn-label-" + id }, label)));
};
exports.RadioButton = RadioButton;
